import "./index.css"
import "./mobile.css";
import { useState, useEffect } from 'react'; // Import useState
import Button from "../button/index.js"

function SettingsBlock({indexNumber,left,top,zIndex,moveFunction,upFunction,downFunction,imageSource,heading,closeFunction,changeColorFunction,changeHeaderFunction,previousStatePass,resetSettings,seizureModeFunction}){
    const [name, setName] = useState('');
    const [subtitle, setSubtitle] = useState('');
    const [previousState,SetPreviousState] = useState({});
    useEffect(() => {
        // Your code here will run only once when the component loads
       let previousStateSet = previousStatePass;
      SetPreviousState(previousStateSet);
      }, []);
      
    const confirmSettings = () => {
        closeFunction(indexNumber)
    }
    
    const handleSettingsClose = () => {
        resetSettings(previousState);
        closeFunction(indexNumber)
    }
    const handleHeadingChanges = (name, subtitle) => {
        // Logic to handle heading changes
        changeHeaderFunction(name, subtitle); // Example action
    };

    // Handlers for input changes
    const handleNameChange = (event) => {
        setName(event.target.value);
        handleHeadingChanges(event.target.value, subtitle);
    };

    const handleSubtitleChange = (event) => {
        setSubtitle(event.target.value);
        handleHeadingChanges(name, event.target.value);
    };
    return <div className="dialog-box settings-box" id={indexNumber} 
    style={{ left: left, 
        top: top, 
        zIndex:zIndex
    }}
    onMouseMove={moveFunction}
    onMouseUp={upFunction}
    data-boxindex={indexNumber}
    >
        <div className="dialog-box-heading big-text draggable-box"
         onMouseDown={downFunction}
         data-boxindex={indexNumber}
        >
            <div className="dialog-box-info draggable-box" data-boxindex={indexNumber}>
                <img className="heading-image draggable-box" src={imageSource} alt="heading" data-boxindex={indexNumber}/>
                <div className='draggable-box' data-boxindex={indexNumber}>{heading}</div>
            </div>
            <img className="close-button" src="./images/UI/close.png" alt="close button" onClick={handleSettingsClose} />
        </div>
    <div className="dialog-box-body small-text">
    <div id="color-picker">
    <div className="color bordered" style={{backgroundColor: "#008989"}} onClick={()=> changeColorFunction("#008989")}></div>
    <div className="color bordered" style={{backgroundColor: "red"}} onClick={()=> changeColorFunction("red")}></div>
    <div className="color bordered" style={{backgroundColor: "blue"}} onClick={()=> changeColorFunction("blue")}></div>
    <div className="color bordered" style={{backgroundColor: "green"}} onClick={()=> changeColorFunction("green")}></div>
    <div className="color bordered" style={{backgroundColor: "purple"}} onClick={()=> changeColorFunction("purple")}></div>
    <div className="color bordered" style={{backgroundColor: "orange"}} onClick={()=> changeColorFunction("orange")}></div>
    </div>
    <div id="desktop-namer">
    <input type="text" placeholder="Set name" className="bordered" maxLength={20} onChange={handleNameChange}></input>
    <input type="text" placeholder="Set subtitle" className="bordered" maxLength={30} onChange={handleSubtitleChange}></input>
    <div className="settings-button-holder">
    <Button text='Shuffle' functionToAdd={seizureModeFunction}></Button>
    <Button text="Confirm" functionToAdd={confirmSettings}></Button>
    </div>
    </div>
    </div>
    </div>
}


export default SettingsBlock